import { api } from '@/utils/api'

export interface SavedItemProfile {
  type: 'profile'
  id: string
  title: string
  snippet?: string
  followers?: number
  url?: string
  saved_at?: number
}

export interface SavedItemTrend {
  type: 'trend'
  id: string
  websearch_query: string
  summary?: string
  quantity?: number
  saved_at?: number
}

export type SavedItem = SavedItemProfile | SavedItemTrend

export async function searchSavedItems(params: { q?: string; limit?: number } = {}) {
  const q = new URLSearchParams()
  if (params.q) q.set('q', params.q)
  if (params.limit != null) q.set('limit', String(params.limit))
  return api.get(`/v0_1/shorts/saved-items?${q.toString()}`)
}

export async function createShort(payload: { title?: string; context_text?: string; context_items?: Array<{ type: 'profile' | 'trend'; id: string }> }) {
  return api.post(`/v0_1/shorts`, payload)
}

export async function generateIdeas(payload: { context_text?: string; context_items?: Array<{ type: 'profile'|'trend'; id: string }> }) {
  return api.post(`/v0_1/shorts/ideas`, payload)
}


